var render = function render(){var _vm=this,_c=_vm._self._c;return _c('http-delete-button',_vm._g(_vm._b({attrs:{"href":`/api/customViews/${(_vm.value || {}).id}`,"version":"v2"},on:{"http4xx":_vm.onError}},'http-delete-button',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }